import React, { Component } from 'react';
import { NormalButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { OUTPUT_TTL } from '../../constants/Pac';
import { DeviceStatusLabel } from './components/labels';

export const WetDryMode = {
  NO: 1,
  NC: 2,
};

@inject('batchStore')
@observer
class Diverter extends Component {
  render() {
    const { device, batchStore } = this.props;
    const name = device.description || `Diverter #${device.id}`;
    const isActive = batchStore.isOutputOn(device.gateOnePNo);
    const duration = isActive ? 0 : OUTPUT_TTL;
    let btnClass = isActive ? 'active' : '';

    if (Number(device.mode) === WetDryMode.NC) {
      btnClass = !isActive ? 'active  btn-batch-red' : ' btn-batch-red';
    }

    return (
      <div id={`device-${device.id}`} className={'device-gui device-gui--diverter'}>
        <DeviceStatusLabel
          name={name}
          status={device.mixerId ? `Mixer #${device.mixerId}` : 'Mixer not set'}
          title={`#${device.id}`}
        />

        <div className="device-icon body"/>
        <div className="device-buttons">
          {!batchStore.running.length && (
            <NormalButton className={`btn-batch ${btnClass}`}
              port={device.gateOnePNo}
              duration={duration}
            >
              <i className="fa fa-power-off"/>
            </NormalButton>
          )}
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Diverter);
